import { ChangeDetectorRef, Component } from '@angular/core';

import { TourHighlightPosition } from './interface';

@Component({
  selector: 'rt-tour-highlight',
  templateUrl: './tour-highlight.html',
  styleUrls: ['./tour-highlight.less'],
  standalone: true,
})
export class TourHighlightComponent {
  public position: TourHighlightPosition;

  constructor(private cdRef: ChangeDetectorRef) {}

  public show(position: TourHighlightPosition): void {
    this.setTransformOrigin(position);
    this.cdRef.detectChanges();
  }

  private setTransformOrigin(value: TourHighlightPosition): void {
    this.position = value;
  }
}
